<!--
    描述：场地管理  -- 新增/编辑页
    时间： 2020/9/28
    Created by zl
-->
<template>
	<div class="filed-info-layout">
		<div class="common-top" ref="formRef">
			<el-form class="meeting" label-width="140px" ref="fieldRef" :model="msgForm" :rules="msgRule">
				<div class="top-area" v-if="this.$route.query.type == 'edit'">
					<el-row>
						<el-col :span="24">
							<el-form-item prop="sname" label="场地名称：">
								<el-input v-model="msgForm.sname" :disabled="disabled" placeholder="请输入场地名称"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item prop="unit" label="场地所属单位：">
								<el-select v-model="msgForm.unit" placeholder="请选择场地所属单位" :disabled="disabled">
									<el-option v-for="item in departmentList" :key="item.id" :value="item.id" :label="item.sname"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="场地地址：" class="special-item" required>
								<address-form v-model="msgForm.area" :disabled="disabled"></address-form>
							</el-form-item>
						</el-col>
					</el-row>
				</div>

				<div class="top-area" v-if="this.$route.query.type == 'add'">
					<el-row class="addView">
						<el-col :span="12">
							<el-form-item label="场地名称：">
								<span>{{ adressObj.sname }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="addView">
						<el-col :span="12">
							<el-form-item label="场地所属单位：">
								<span>{{ adressObj.tenantSname }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="addView">
						<el-col :span="12">
							<el-form-item label="场地地址：">
								<span>{{ adressObj.detailAdd }} {{ adressObj.address }}</span>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<el-divider content-position="left"><span class="title">会议室信息</span></el-divider>
				<div v-for="(item, index) in msgForm.addMeetingList" :ref="'list' + index" :key="'item' + index">
					<el-row class="add-area">
						<el-col :span="18">
							<div class="add-box">
								<el-row>
									<el-col :span="12">
										<el-form-item
											label="会议室名称："
											:prop="'addMeetingList.' + index + '.sname'"
											:rules="[{ required: true, message: '请填写会议室名称' }]"
										>
											<el-input
												v-model="item.sname"
												placeholder="请输入会议室名称"
												:disabled="item.disabled"
												@blur="checkName(item.sname, index)"
												maxlength="6"
												show-word-limit
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="会议室类型："
											:prop="'addMeetingList.' + index + '.typeList'"
											:rules="[{ required: true, message: '请选择会议类型' }]"
										>
											<el-checkbox-group v-model="item.typeList" :disabled="item.disabled">
												<el-checkbox v-for="(item1, index) in hyslx" :key="'hyslx' + index" :label="item1.value">
													{{ item1.sname }}
												</el-checkbox>
											</el-checkbox-group>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="场地容纳人数："
											:prop="'addMeetingList.' + index + '.galleryful'"
											:rules="[{ required: true, message: '请输入场地容纳人数' }]"
										>
											<el-input
												placeholder="请输入场地容纳人数"
												:disabled="item.disabled"
												type="number"
												min="0"
												maxlength="9"
												v-model="item.galleryful"
												@keyup.native="item.galleryful = person(item.galleryful)"
											>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="会议室价格："
											:prop="'addMeetingList.' + index + '.price'"
											:rules="[{ required: true, message: '请输入会议室价格' }]"
										>
											<el-input
												v-model="item.price"
												:disabled="item.disabled"
												v-input-filter:price
												maxlength="12"
												@keyup.native="item.price = oninput(item.price)"
											>
												<template slot="append">元 / 天</template>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="会议室面积："
											:prop="'addMeetingList.' + index + '.area'"
											:rules="[{ required: true, message: '请输入会议室面积' }]"
										>
											<el-input
												v-model="item.area"
												:disabled="item.disabled"
												maxlength="12"
												@keyup.native="item.area = oninput(item.area)"
											>
												<template slot="append">平方米</template>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item
											label="会议室配置信息："
											:prop="'addMeetingList.' + index + '.configura'"
											:rules="[{ required: true, message: '请选择会议室配置信息' }]"
										>
											<el-checkbox-group v-model="item.configura" :disabled="item.disabled">
												<el-checkbox v-for="(item1, index) in hyspzxx" :key="'hyspzxx' + index" :label="item1.value">
													{{ item1.sname }}
												</el-checkbox>
											</el-checkbox-group>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="计算机mac白名单" :prop="'addMeetingList.' + index + '.macOpen'">
											<el-radio-group v-model="item.macOpen">
												<el-radio :label="0" :disabled="item.disabled">关闭</el-radio>
												<el-radio :label="1" :disabled="item.disabled">开启</el-radio>
											</el-radio-group>
											<el-input
												v-model="item.macs"
												placeholder="请输入白名单mac，多个计算机请以 ; 隔开"
												:disabled="item.macOpen == 0 || item.disabled"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col>
										<el-form-item label="场地照片：" :prop="'addMeetingList.' + index + '.placeImg'">
											<public-upload
												:ref="`meetingImgUpload${index}`"
												listType="picture-card"
												tableName="operate_meeting"
												forDatabase="meeting"
												:aid="item.id"
												:acceptType="acceptArr"
												:maxNum="4"
												:mode="item.disabled ? 'view' : ''"
												:needRefresh="false"
												assortment="operate_meeting"
												:hoverImg="true"
											></public-upload>
											<p class="tips">最多上传四张图片</p>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</el-col>
						<el-col :span="4" :offset="2" class="do-bar">
							<i class="add-btn el-icon-plus btn-icons" @click="addMettingInfo"></i>
							<i class="del-btn el-icon-minus btn-icons" v-if="msgForm.addMeetingList.length != 1" @click="deleteRow(item, index)"></i>
						</el-col>
					</el-row>
				</div>

				<div id="bottom-box"></div>
			</el-form>
		</div>
		<div class="foot-btn">
			<el-button size="small" icon="el-icon-edit-outline" @click="submitForm">保存</el-button>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { saveOrUpdateOperateMeeting, getOperateInfo, getoperateMeetingList, getOperateTenantMapList, detailAdd } from 'api/modules/fieldManagement'
import addressForm from 'components/addressForm/addressForm'
export default {
	components: {
		addressForm
	},
	props: {
		companyId: {
			type: String,
			default: ''
		},
		adressObj: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			msgForm: {
				sname: '', //场地名称
				unit: '', //场地所属单位
				area: {}, //场地地址
				address: '',
				operateMeetingList: [
					{
						id: this.$SnowFlake.nextId(),
						siteId: '',
						sname: '',
						type: '',
						applySys: '',
						typeList: [],
						galleryful: '',
						price: 0,
						area: 0,
						configuration: [],
						configura: [],
						macOpen: 0,
						macs: '',
						isFlag: 1
					}
				],
				// 新增用的数组
				addMeetingList: []
			},
			yyxt: [
				{ sname: '安招采', value: '1017001' },
				{ sname: '经营', value: '1017002' },
				{ sname: '实施', value: '1017003' },
				{ sname: '办公OA', value: '1017004' }
			],
			area: {},
			msgRule: {
				sname: [
					{
						required: true,
						message: '请填写场地名称',
						tirgger: 'blur'
					}
				],
				unit: [
					{
						required: true,
						message: '请选择场地所属单位',
						tirgger: 'blur'
					}
				]
			},
			nameRule: [
				{
					required: true,
					message: '请填写会议室名称',
					tirgger: 'blur'
				}
			],
			departmentList: [],
			valueList: {},
			copyList: [],
			acceptArr: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'GIF', 'JPG', 'PNG'],
			delObj: {}
		}
	},
	created() {
		this.companyId == '' ? this.goBack() : ''
		this.routeQuery == 'edit' ? this.getOperateSiteInfo() : ''
		this.getDepartments()
		this.getPlaceMeeting()
	},
	methods: {
		//点击会议室信息
		addMettingInfo(type) {
			this.msgForm.addMeetingList.push({
				id: this.$SnowFlake.nextId(),
				siteId: '',
				sname: '',
				type: '',
				typeList: [],
				galleryful: '',
				price: 0,
				applySys: '',
				area: 0,
				macOpen: 0,
				macs: '',
				configuration: [],
				configura: [],
				isFlag: 1
			})
			this.$nextTick(() => {
				if (type == '1') {
					return
				}
				setTimeout(() => {
					document.querySelector('#bottom-box').scrollIntoView({
						behavior: 'smooth',
						block: 'end'
					})
				}, 100)
			})
		},

		// 删除一条记录
		deleteRow(data, index) {
			this.$confirm('此操作将永久删除该会议室, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.msgForm.addMeetingList.forEach((item) => {
						if (item.id == data.id) {
							item.isFlag = 0
							this.delObj = Object.assign({}, item)
						}
					})
					this.msgForm.addMeetingList.splice(index, 1)
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},

		// 获取所属单位
		getDepartments() {
			getOperateTenantMapList().then((d) => {
				if (d.code == 0) {
					this.departmentList = d.data
				}
			})
		},

		// 获取当前场地的信息
		getOperateSiteInfo() {
			getOperateInfo({
				id: this.companyId
			}).then((d) => {
				if (d.code == 0) {
					let params = Object.assign({}, d.data)
					params.area = {}
					params.area.province = {
						value: params.province
					}
					params.area.city = {
						value: params.city
					}
					params.area.area = {
						value: d.data.area
					}
					params.area.detail = params.address
					this.msgForm = params
				}
			})
		},

		// 获取会议室信息
		getPlaceMeeting() {
			getoperateMeetingList({
				siteId: this.companyId,
				type: ''
			})
				.then((d) => {
					let params = d.data.records
					if (params.length >= 1) {
						params.forEach((item, index) => {
							item.configura = item.configuration.split(',')
							// item.applySysArr = item.applySys.split(",");
							item.typeList = item.type.split(',')
							item.disabled = true
						})
						this.msgForm.operateMeetingList = params
					}
				})
				.finally(() => {
					this.addMettingInfo('1')
				})
		},

		// 返回
		goBack() {
			this.$router.replace({
				path: '/redirect' + this.$route.path,
				params: { id: this.companyId },
				query: {
					type: 'Area'
				}
			})
		},

		// 场地信息修改保存
		savePlace() {
			if (this.routeQuery == 'edit') {
				let params = Object.assign({}, this.msgForm)
				params.province = params.area.province.value
				params.city = params.area.city.value
				params.address = params.area.detail
				params.detailAdd = params.area.province.name + params.area.city.name + params.area.area.name
				params.area = params.area.area.value
				detailAdd(params).then((d) => {})
			}
		},

		// 保存
		submitForm() {
			this.$refs.fieldRef.validate((valid) => {
				if (valid) {
					// 保存场地信息
					this.savePlace()
					// 保存会议室信息
					let operateMeetingList = this.msgForm.addMeetingList
					this.delObj.id ? operateMeetingList.push(this.delObj) : ''
					operateMeetingList.forEach((item) => {
						item.configuration = item.configura.join(',')
						item.type = item.typeList.join(',')
						item.newFlag = this.routeQuery == 'add' ? 0 : 1
						// item.applySys = item.applySysArr.join(",");
					})
					saveOrUpdateOperateMeeting({
						id: this.companyId,
						operateMeetingList
					}).then((d) => {
						if (d.code == 0) {
							this.$emit('on-reset')
							this.goBack()
						}
					})
				} else {
					this.$message.warning('请完善表单信息！')
				}
			})
		},

		// 校验金额
		oninput(num) {
			let str = num.toString()
			let len1 = str.substr(0, 1)
			let len2 = str.substr(1, 1)
			//如果第一位是0，第二位不是点，就用数字把点替换掉
			if (str.length > 1 && len1 == 0 && len2 != '.') {
				str = str.substr(1, 1)
			}
			//第一位不能是.
			if (len1 == '.') {
				str = ''
			}
			//限制只能输入一个小数点
			if (str.indexOf('.') != -1) {
				var str_ = str.substr(str.indexOf('.') + 1)
				if (str_.indexOf('.') != -1) {
					str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
				}
			}
			//正则替换
			str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
			// str = str.replace(/\.\d\d\d$/, '') // 小数点后只能输两位
			return str
		},

		// 校验人数
		person(num) {
			if (num != '') {
				let str = num.toString()
				str = str.replace(/[^\.\d]/g, '')
				str = str.replace('.', '')
				if (str.length > 9) {
					str = str.substr(0, 9)
					this.$message.warning('最长9位')
					return parseInt(str)
				}
				return parseInt(str)
			} else {
				return ''
			}
		},

		// 校验会议室名称
		checkName(data, index) {
			data = data.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '')
			let arr = this.msgForm.addMeetingList
			arr[index].sname = data
			let newArr = []
			arr.forEach((item) => {
				if (item.sname == data && data != '') {
					newArr.push(item)
				}
			})
			if (newArr.length > 1) {
				arr[index].sname = ''
				this.$message.warning('会议室名称不可重复！')
			}
		}
	},
	computed: {
		...mapState('place_dict', { hyslx: (state) => state.hyslx }),
		...mapState('place_dict', { hyspzxx: (state) => state.hyspzxx }),
		routeQuery() {
			return this.$route.query.type
		},
		disabled() {
			return this.adressObj.tag == '1001002'
		}
	},
	watch: {}
}
</script>
<style lang="less" scoped>
.filed-info-layout {
	height: 100%;
	padding: 0 10px 0px 30px;
	background-color: #fff;
	overflow-y: auto;
	.common-top {
		height: 100%;
		padding-bottom: 30px;
		padding-top: 20px;
		position: relative;
		.special-item {
			/deep/ .el-form-item__content {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-around;
			}
			/deep/ .el-select {
				flex: 1;
				width: 33.3%;
			}
			/deep/ .el-select + .el-select {
				margin-left: 15px;
			}
			.detail-msg {
				margin-top: 15px !important;
			}
		}
	}
	.el-icon-circle-plus {
		font-size: 30px;
		color: #009900;
		cursor: pointer;
	}
	.add-meeting {
		color: #256ccb;
		font-size: 12px;
		margin-left: 10px;
		cursor: pointer;
	}
	.add-area {
		margin-top: 30px;
		margin-bottom: 20px;
		border-bottom: 2px dotted #eee;
		.add-btn {
			background-color: #409eff;
		}
		.del-btn {
			background-color: #f44336;
		}
		.btn-icons {
			display: block;
			width: 50px;
			line-height: 50px;
			height: 50px;
			text-align: center;
			font-size: 20px;
			color: #fff;
			cursor: pointer;
		}
	}
	/deep/ .el-input-group__append {
		background-color: #256ccb;
		color: #fff;
	}
	.meeting {
		height: 100%;
		overflow-y: auto;
	}
	.foot-btn {
		position: absolute;
		top: 88px;
		right: 135px;
		.el-button {
			height: 28px !important;
		}
	}
	.line {
		margin-top: 0px;
	}
	.tips {
		font-size: 12px;
		color: #606266;
		height: 20px;
		line-height: 20px;
	}
	.do-bar {
		display: flex;
		flex-direction: column;
	}
	.addView {
		/deep/ .el-form-item {
			margin-bottom: 0 !important;
		}
	}
	.title {
		font-size: 17px;
		font-weight: bold;
	}
}
</style>
